import client from "./client";

export const searchUsers = (abilityLevel) =>
  client.get("/users/search", { params: abilityLevel ? { abilityLevel } : {} }).then((r) => r.data);
